import React, { useState } from 'react';
import { Toast } from '../ui/Toast';
import { useLoader } from '../../contexts/LoaderContext';
import HoraPilotPaiementHistory from '../HoraPilotPaiementHistory';
import api from '../../services/api';

// ============================================================================
// REGISTRE MODULE — Historique des paiements
// ============================================================================
// Wrapper autour de HoraPilotPaiementHistory existant
// Ajoute juste le contexte (loader, toast, API calls)
// ============================================================================

const RegistreModule = () => {
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const { showLoader, hideLoader } = useLoader();

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  // Charger l'historique des paiements
  const loadHistoriqueData = async () => {
    showLoader();
    try {
      const response = await api.paiementsSalaires.getHistoriquePaiementsEmployes();
      if (response.success) {
        return response.data;
      } else {
        showToast('Erreur lors du chargement de l\'historique', 'error');
        return [];
      }
    } catch (error) {
      console.error('Erreur chargement historique:', error);
      showToast('Erreur lors du chargement de l\'historique', 'error');
      return [];
    } finally {
      hideLoader();
    }
  };

  // Télécharger une fiche de paie
 const handleDownloadFichePaie = async (paiementId) => {
  try {
    showToast('Génération du bulletin en cours...', 'loading');
    await api.paiementsSalaires.exportBulletin(paiementId);
    showToast('Bulletin PDF téléchargé !', 'success');
  } catch (error) {
    console.error('Erreur téléchargement fiche:', error);
    showToast('Erreur lors du téléchargement', 'error');
  }
};

  return (
    <div className="min-h-screen p-6" style={{ backgroundColor: '#fdfcf5' }}>
      <HoraPilotPaiementHistory
        loadData={loadHistoriqueData}
        onDownloadFiche={handleDownloadFichePaie}
        showToast={showToast}
      />

      {/* Toast */}
      {toast.show && (
        <Toast
          show={toast.show}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ show: false, message: '', type: '' })}
        />
      )}

      
    </div>
  );
};

export default RegistreModule;